module.exports = __webpack_public_path__ + "static/img/tipsGreen.869513bc.png";